import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/AuthStyles.css';

const LoginPage: React.FC = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(formData.email, formData.password);
            navigate('/');
        } catch (err: any) {
            setError(err.message || 'Erreur lors de la connexion');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <h1 className="auth-logo">Eldaï</h1>
                        <h2 className="auth-title">
                            Connexion à votre compte
                        </h2>
                        <p className="auth-subtitle">
                            Ou{' '}
                            <Link to="/register">
                                créez un nouveau compte
                            </Link>
                        </p>
                    </div>

                    <form className="auth-form" onSubmit={handleSubmit}>
                        {error && (
                            <div className="auth-error">
                                {error}
                            </div>
                        )}

                        <div className="auth-fields">
                            <div className="auth-field">
                                <label htmlFor="email" className="auth-label">
                                    Email
                                </label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="auth-input"
                                    placeholder="votre@email.com"
                                />
                            </div>

                            <div className="auth-field">
                                <label htmlFor="password" className="auth-label">
                                    Mot de passe
                                </label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    required
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="auth-input"
                                    placeholder="Votre mot de passe"
                                />
                            </div>
                        </div>

                        <div className="forgot-password">
                            <button
                                type="button"
                                className="forgot-password-link"
                                onClick={() => {
                                    // TODO: Implement forgot password functionality
                                    alert('Fonctionnalité de mot de passe oublié à venir');
                                }}
                            >
                                Mot de passe oublié ?
                            </button>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className={`auth-button ${loading ? 'loading' : ''}`}
                        >
                            {loading ? 'Connexion...' : 'Se connecter'}
                        </button>

                        <div className="auth-footer">
                            <span className="auth-footer-text">
                                Vous n'avez pas de compte ?{' '}
                                <Link to="/register">
                                    Inscrivez-vous maintenant
                                </Link>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
